import { getPackagesProjectWithTeamidAndUuid } from 'api/cloudApiGenerated';
import { copyTextToClipboard } from 'pages/ProjectsPage/helpers/ProjectsPageHelper';

export const sendPackagePayload = async (project: { uuid: string }, team: { id: number }, useLink?: boolean) => {
  const { uuid } = project;

  const response = await getPackagesProjectWithTeamidAndUuid(team?.id, uuid);

  const { embed_code } = response;
  const iframe = embed_code;
  const iframeUrl = iframe.split('"')[1].replaceAll("'", '');

  console.log(iframe, iframeUrl, useLink);

  console.log(useLink, useLink ? iframeUrl : iframe);
  copyTextToClipboard(useLink ? iframeUrl : iframe, true);
};
